import { marked } from "marked";

// Custom tokenizer to preserve literal text in code blocks
const tokenizer = {
  code(src) {
    // Match fenced code blocks
    const match = src.match(/^```([^\n]*)\n([\s\S]*?)\n```/);
    if (match) {
      return {
        type: 'code',
        raw: match[0],
        lang: match[1].trim() || undefined,
        text: match[2]  // Keep text as-is, don't parse markdown
      };
    }
    // Fallback to default code tokenizer
    return false;
  }
};

// Configure marked for safe rendering with custom tokenizer
marked.setOptions({
  breaks: true,          // Convert \n to <br>
  gfm: true,            // Enable GitHub flavored markdown
  headerIds: false,     // Don't add IDs to headers
  mangle: false,        // Don't mangle email addresses
  sanitize: false,      // Don't sanitize HTML (handled by DOMPurify)
  silent: true          // Don't log errors
});

marked.use({ tokenizer });

// The legacy mobile-chat script in app/views/home/_inline_chat.html.erb is a plain
// (non-module) script and reads the global - without this it used to fetch an old
// marked build from a CDN at runtime.
window.marked = marked;

// Export the configured marked instance
export { marked };
